module.exports = __webpack_public_path__ + "img/eight7Green.e761fa9c.jpg";